export enum LoginMethod {
  LOGIN_WITH_USER_PASSWORD,
  LOGIN_WITH_CUSTOM_TOKEN,
}
